import React from "react";
import { Form, Field } from "react-final-form";
import { withRouter } from "next/router";
import Router from "next/router";
import InputText from "@components/Form/InputText";

const handleFormSubmit = ({ search }) => {
  // merge cu gateway-ul de live. Pe stage apar erori CORS
  Router.push(`/suport-clienti/cauta/?qs=${search}`);
};

const SupportSearchForm = ({ router, label = null, hasTitle = true }) => (
  <>
    {/* is-hidden-in-mobile-app-contact-page class is used to hide this content in the WebView used contact sections in mobile app */}
    <section
      className={`
      is-hidden-in-mobile-app-contact-page
      py-4
      lg:py-0
      ${hasTitle == true && label ? "lg:mt-12" : "mt-4 lg:mt-0"}
    `}
    >
      {hasTitle && label}

      <div className={`md:w-524px mx-auto`}>
        <Form
          onSubmit={handleFormSubmit}
          initialValues={{
            search: router.query.qs || "",
          }}
          render={({ handleSubmit, submitting }) => {
            return (
              <form
                onSubmit={handleSubmit}
                className="w-full mt-4"
                autoComplete="off"
              >
                <div className="relative">
                  <Field
                    name="search"
                    component={InputText}
                    placeholder="Cauta in articolele de suport"
                    minLength="3"
                    maxLength="50"
                    required
                    className={`
                        SearchInputComponent
                        w-full mb-0 text-black border border-gray-light p-3 pl-5
                        rounded-bl-lg
                        rounded-tr-lg bg-white
                        focus:border-black outline-none
                      `}
                  />
                  <button
                    type="submit"
                    title={`Cauta`}
                    disabled={submitting}
                    className="v-align-middle-abs right-3 pl-3 ie-top"
                  >
                    <svg
                      width="17"
                      height="17"
                      viewBox="0 0 17 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M11.4834 13.0863L12.8167 11.7529L15.8499 14.7861C16.2181 15.1543 16.2181 15.7513 15.8499 16.1195C15.4818 16.4877 14.8848 16.4877 14.5166 16.1195L11.4834 13.0863Z"
                        fill="#ADADAD"
                      />
                      <circle
                        cx="7.5"
                        cy="7.5"
                        r="6.75"
                        stroke="#ADADAD"
                        strokeWidth="1.5"
                      />
                    </svg>
                  </button>
                </div>
              </form>
            );
          }}
        />
      </div>
    </section>
  </>
);

export default withRouter(SupportSearchForm);
